module.exports = __webpack_public_path__ + "static/fishing-short-9ddaecaae97ea3925f5a7a67e58bfe47.mp4";